<template>
  <div>
    <div v-show="isOpen" v-bind:class="{ show: isOpen }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalWrapper',
  props: {
    isOpen: Boolean
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.toggleBodyOverflow(true);
      } else {
        this.toggleBodyOverflow(false);
      }
    }
  },
  methods: {
    toggleBodyOverflow(isOpen) {
      document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    }
  }
};
</script>
